<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <the-page :pageId="pageId" :appConfig="appConfig" class="marking-page" embeddedMode>
    <page-title :title="title">
      <template v-if="data" #titleSuffix>
        <span class="marking-page__progress">
          <a-progress
            class="marking-page__progress-bar"
            status="normal"
            :percent="(itemsMarked / itemsTotal) * 100"
            :showInfo="false"
          />
          <span>{{ itemsMarked }} из {{ itemsTotal }}</span>
        </span>
        <a-checkbox v-model="showOnlyUnmarked" class="marking-page__filter-checkbox">
          Только не размеченные
        </a-checkbox>
        <span v-if="totalCount">
          Всего задач: <b>{{ totalCount }}</b>
        </span>
        <span>
          <input-enum
            v-model="region"
            label="Регион"
            :options="regions"
            :allowClear="false"
            style="min-width: 250px; width: 100%; background: none"
          />
        </span>
      </template>
    </page-title>
    <div :class="['marking-page__wrapper', { 'marking-page__wrapper-norules': !rules }]">
      <page-block class="marking-page__main" :isLoading="isLoading">
        <a-alert v-if="!isLoading && !config" message="Конфиг не найден" type="info" showIcon />
        <a-alert v-else-if="error" message="Не найдено задач на разметку" />
        <div v-else-if="data" class="marking-page__list">
          <div
            v-for="(item, index) of itemsToDisplay"
            :key="index"
            :class="['product-card', { 'product-card__checked': !!item.result }]"
          >
            <a-row :gutter="24">
              <a-col :span="24">
                <div v-for="column of config.customprops.table.columns" :key="column.dataIndex">
                  <b>{{ column.title }}:</b> {{ item.data[column.dataIndex] }}
                </div>
              </a-col>
              <!--              <a-col :span="1">-->
              <!--                <a-icon-->
              <!--                  class="product-card__details uploader-image__control"-->
              <!--                  style="text-align: right"-->
              <!--                  type="eye"-->
              <!--                  @click="clickAction(item.data)"-->
              <!--                />-->
              <!--              </a-col>-->
            </a-row>

            <a-radio-group
              v-model="item.result"
              name="checkboxgroup"
              :options="config.customprops.errorTypes"
            />
            <a-button class="product-card__category-selector" @click="openCategorySelector(item)">
              Изменить товар (услугу)-представитель
              <a-icon type="down" />
            </a-button>
          </div>
        </div>
        <a-alert
          v-if="showOnlyUnmarked && itemsMarked === itemsTotal && !error"
          message="Все элементы размечены"
        />
      </page-block>
      <div v-if="rules" class="marking-page__instruction">
        <h2>Инструкция по разметке</h2>
        <div v-html="rules"></div>
      </div>
      <div class="marking-page__footer">
        <a-button type="primary" :disabled="submitDisabled" @click="submit">
          <a-icon
            v-if="config && config.customprops.submit.icon"
            :type="config.customprops.submit.icon"
          />
          {{ config && config.customprops.submit.buttonText }}
        </a-button>
        <a-button type="default" @click="cancel">
          <a-icon
            v-if="config && config.customprops.cancel.icon"
            :type="config.customprops.cancel.icon"
          />
          {{ config && config.customprops.cancel.buttonText }}
        </a-button>
      </div>
    </div>

    <a-modal
      width="1170px"
      :visible="showModal"
      :bodyStyle="modalBodyStyle"
      :title="'Полученные данные'"
      :footer="null"
      :closable="false"
      transitionName="none"
      maskTransitionName="none"
      @cancel="showModal = false"
    >
      <div class="entity-modal">
        <div class="modal" style="padding: 2%">
          <pre v-if="es_result.length">{{ es_result }}</pre>
          <p v-else>Первичные данные не найдены.</p>
        </div>
      </div>
    </a-modal>

    <category-selector
      :active="!!categorySelectionItem"
      :config="config"
      :appConfig="appConfig"
      @close="closeCategorySelector"
      @select="closeCategorySelector"
    />
  </the-page>
</template>

<script>
import axios from 'axios';
import { bus, storage } from '@/helpers';
import store from '@/store';
import ThePage from '@/components/page/ThePage.vue';
import PageTitle from '@/components/page/PageTitle';
import PageBlock from '@/components/page/PageBlock.vue';
import CategorySelector from '@/components/category-selector/CategorySelector.vue';
import TABLE_QUERY from '@/queries/table';
import { apolloClient } from '@/apolloClient';
import InputEnum from '@/components/base/InputEnum.vue';

const apiUrl = process.env.VUE_APP_ROSSTAT_API_URL;
const esUrl = process.env.VUE_APP_ELASTIC_URL;

export default {
  name: 'TheDataMarkingPage',
  components: {
    ThePage,
    PageBlock,
    PageTitle,
    CategorySelector,
    InputEnum,
  },

  props: {
    appConfig: {
      type: Object,
      default: null,
    },
    category: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      data: null,
      date: null,
      loading: true,
      isModalVisible: false,
      rulesId: null,
      page: null,
      rules: null,
      es_result: [],
      showModal: false,
      showOnlyUnmarked: false,
      categorySelectionItem: null,
      scrollPosition: null,
      error: '',
      region: '',
      regions: [],
      totalCount: null,
      itemsMarked: 0,
      itemsToDisplay: [],
      region_search: '',
    };
  },

  computed: {
    config() {
      return (
        store.state.activeSidebarItem?.customprops.tableRowLinkedComponent ||
        store.state.activeSidebarItem
      );
    },
    isLoading() {
      return this.loading || this.config === undefined;
    },
    code() {
      return this.config?.code;
    },
    title() {
      return this.category;
    },
    pageId() {
      return this.$route.params.type;
    },
    modalBodyStyle() {
      return {
        height: '70vh',
        maxWidth: '1170px',
        width: '100%',
        backgroundColor: '#f9f9f9',
      };
    },
    itemsTotal() {
      return this.data?.length;
    },
    submitDisabled() {
      return !this.data || this.itemsMarked < this.itemsTotal;
    },
  },

  watch: {
    data() {
      this.itemsMarked = this.data?.filter((item) => item.result !== undefined).length;
      this.itemsToDisplay = this.showOnlyUnmarked
        ? this.data.filter((item) => item.result === undefined)
        : this.data;
    },
    showOnlyUnmarked() {
      this.itemsToDisplay = this.showOnlyUnmarked
        ? this.data.filter((item) => item.result === undefined)
        : this.data;
    },
    // config: {
    //   immediate: true,
    //   async handler(value) {
    //     if (value) {
    //       this.requestData();
    //       // if (!this.config?.customprops.rules) {
    //       //   this.requestRulesId();
    //       // }
    //     }
    //   },
    // },
    code: {
      immediate: true,
      handler(value) {
        if (value) {
          this.page = storage.get(`data_markup_page_${this.code}`) || 0;
          this.requestRules();
        }
      },
    },
    category: {
      immediate: true,
      handler(value) {
        if (value) {
          this.requestData();
        }
      },
    },
    region() {
      this.requestData();
    },
  },

  async mounted() {
    this.get_regions();
    this.requestData();
  },
  updated() {
    document
      .getElementsByClassName('page marking-page')[0]
      .addEventListener('scroll', this.updateScroll);
  },
  beforeDestroy() {
    document
      .getElementsByClassName('page marking-page')[0]
      .removeEventListener('scroll', this.updateScroll);
  },
  methods: {
    regionSearch(value) {
      this.region_search = value || '';
      this.get_regions();
    },
    async get_regions() {
      // const prevRegion = this.region;
      const client = apolloClient
        .query({
          ...TABLE_QUERY,
          variables: {
            type: 'Region',
            page: 0,
            pageSize: 10000,
            // filters: [
            //   {
            //     field: "name_region",
            //     value: this.region_search,
            //     operator: "ILIKE"
            //   }
            // ],
          },
        })
        .catch((error) => {
          bus.$emit('error', {
            from: 'configFormLayout',
            description: `Ошибка получения конфига таблицы регионов`,
          });
          throw error;
        });

      client.then((res) => {
        const arr = [];
        res.data.table.documents.forEach(({ data }) => {
          arr[data.name_region] = data.okato;
        });
        this.regions = Object.keys(arr);
        this.region_code_arr = arr;
        this.region =
          Object.keys(this.region_code_arr).find((el) => arr[el] === store.state.region) ?? 'ЦА';
        this.selected_okato = this.region_code_arr[this.region];
      });
    },
    async requestRules() {
      const parent = await this.$apollo.query({
        ...TABLE_QUERY,
        variables: {
          type: this.config.code,
          page: 0,
          pageSize: 1,
          filters: [
            {
              field: 'name',
              operator: 'EQUALS',
              value: this.category,
            },
          ],
          orders: [],
        },
      });

      this.rules = parent.data.table.documents[0].data.instruction;
      this.requestData();
    },
    async requestData() {
      if (this.page === null || !this.category) return;
      const region = this.region
        ? this.region_code_arr[this.region] || store.state.region
        : store.state.region;
      if (!region) return;
      this.loading = true;
      const { data } = await this.axios.get(`${apiUrl}/report/${this.config.customprops.source}`, {
        params: {
          username: store.state.user.username,
          region,
          category: this.category,
          count_tasks: 10,
        },
        // headers: {
        //   'finch-auth': `Bearer ${storage.get('authToken')}`
        // }
      });
      if (data[data.length - 1].count) {
        this.totalCount = data.pop().count.hits.total.value;
      }
      if (data.length) {
        this.error = false;
        this.data = data.map((dataItem) => ({
          type: undefined,
          data: dataItem,
        }));
      } else {
        this.data = [];
        this.error = true;
      }

      this.itemsToDisplay = this.showOnlyUnmarked
        ? this.data.filter((item) => item.result === undefined)
        : this.data;
      this.loading = false;
    },

    async requestRulesId() {
      if (!this.config) return;
      this.$apollo
        .query({
          ...TABLE_QUERY,
          variables: {
            type: 'Rules',
            page: 0,
            pageSize: 1,
            filters: [
              {
                field: 'urn',
                operator: 'EQUALS',
                value: this.config.customprops.rules,
              },
            ],
            orders: [],
          },
        })
        .then(({ data: { table } }) => {
          this.rulesId = table?.documents?.[0]?.id;
        });
    },

    async submit() {
      this.loading = true;

      await this.axios
        .post(
          `${apiUrl}/report/create_errors`,
          this.data.map((item) => ({
            type: item.result,
            username: store.state.user.username,
            fio: store.state.userFio || '',
            category: this.category,
            adjustment: item.adjustment || false,
            new_category: item.new_category || '',
            original_name: item.data.original_name,
            token_name: item.data.token_name,
          })),
          {
            headers: {
              'finch-auth': `Bearer ${storage.get('authToken')}`,
              fio: encodeURIComponent(store.state.userFio),
              region: encodeURIComponent(store.state.regionName),
            },
          },
        )
        .then(() => {
          this.$notification.success({
            message: 'Данные сохранены',
          });
        });

      this.page++;
      storage.set(`data_markup_page_${this.code}`, this.page);
      setTimeout(this.requestData, 2000);
    },
    async cancel() {
      this.data = this.data.map((el) => ({
        data: el.data,
        type: el.type,
      }));
    },
    async clickAction(entity) {
      this.es_result = [];
      const action_params = this.config.action_params;
      const dataRequest = axios.CancelToken.source();
      const body = {
        size: '10000',
        query: {
          term: {},
        },
      };
      body.query.term[`${action_params.search_param}.keyword`] =
        entity[action_params.search_column];
      const { data } = await this.axios.post(
        `${esUrl}/${action_params.es_index}/_search?pretty`,
        body,
        {
          cancelToken: dataRequest.token,
        },
      );
      data.hits.hits.forEach((el) => {
        this.es_result.push(el._source);
      });
      this.showModal = true;
    },

    openCategorySelector(item) {
      this.categorySelectionItem = item;
    },

    closeCategorySelector(category) {
      if (category) {
        const element = this.data.find((el) => el === this.categorySelectionItem);
        element.new_category = category;
        element.adjustment = true;
        element.result = 'class_error';

        this.itemsMarked = this.data?.filter((item) => item.result !== undefined).length;
        this.itemsToDisplay = this.showOnlyUnmarked
          ? this.data.filter((item) => item.result === undefined)
          : this.data;
        // @TODO no backend 10.11
        this.$notification.success({
          message: 'Корректировка применена.',
        });
      }

      this.categorySelectionItem = null;
    },

    updateScroll() {
      this.scrollPosition = document.getElementsByClassName('page marking-page')[0].scrollTop;
      const line = 30.0;

      const el = document.getElementsByClassName('page-title__wrap-header')[0];
      if (this.scrollPosition > line) {
        el.style.position = 'sticky';
        el.style.background = '#fff';
        el.style.boxShadow = '0px 5px 10px rgba(155, 171, 197, 0.3)';
      }
      if (this.scrollPosition <= line) {
        el.style.position = 'block';
        el.style.background = 'none';
        el.style.boxShadow = 'none';
      }
    },
  },
};
</script>

<style lang="scss">
.marking-page {
  .page-title {
    z-index: 10;
    top: 0px;
    position: sticky;

    .cancel_btn {
      border: 2px solid #acbed7;
    }
  }

  .page-title__wrap-header {
    align-items: center;
    flex-wrap: wrap;
    padding: 1rem 2rem;
    margin: 2rem 0;

    h1 {
      margin-bottom: 0.5rem;
    }
    .ant-row-flex {
      align-items: center;
      .ant-col {
        margin-right: 20px;
      }
    }
  }

  &__progress {
    margin: 0 3rem 0;
    display: flex;
    align-items: center;

    span {
      margin-left: 1.2rem;
      font-size: 14px;
      font-weight: 600;
      line-height: 14px;
      color: #366dbb;
      transform: translateY(1px);
    }
  }

  &__progress-bar {
    width: 120px;

    .ant-progress-inner {
      border: 1px solid #366dbb;
      border-radius: 2rem;
      background-color: #fff;
    }
  }

  &__filter-checkbox {
    font-weight: 600;
    font-size: 14px;
    line-height: 14px;
    color: $darkTextColor;
    //margin-bottom: 2rem;
  }

  &__footer {
    text-align: left;
    flex: 1 1 100%;
    padding-top: 40px;

    .anticon {
      color: inherit !important;
      font-size: larger;
    }

    .ant-btn:not(:last-child) {
      margin-right: 2rem;
    }
  }

  &__wrapper {
    padding-bottom: 30px;
    display: flex;
    flex-wrap: wrap;

    .marking-page {
      &__main {
        flex: 1 1 70%;
        padding-right: 3rem;
      }
    }

    &-norules {
      height: calc(100% - 40px);

      .marking-page__footer {
        margin-top: 0px;
        padding-top: 20px;
      }
    }
  }

  &__instruction {
    //margin-top: 8px;
    flex: 0 0 30%;
    overflow: hidden;
    border-radius: 8px;
    max-width: 43rem;
    position: sticky;
    top: 90px;
    z-index: 5;
    height: fit-content;

    h2 {
      display: flex;
      margin-bottom: 0;
      align-items: center;
      padding: 0 3rem;
      width: 100%;
      height: 8rem;
      color: #fff;
      font-size: 2.1rem;
      text-align: center;
      background: #acbed7;
    }

    p {
      background-color: #fff;
      padding: 2.5rem;
      font-size: 1.2rem;
    }
  }
}

.product-card {
  position: relative;
  $bgColor: #fff;
  background: $bgColor;
  padding: 16px 20px;
  border: 3px solid $bgColor;
  box-shadow: 0px 5px 10px rgba(155, 171, 197, 0.05);
  border-radius: 8px;

  &__details {
    position: absolute;
    top: -4px;
    right: 6px;
    padding: 5px;
    color: #243041 !important;
  }

  &:not(:last-child) {
    margin-bottom: 25px;
  }

  &__checked {
    //background-color: darken($bgColor, 10%);
    border: 3px solid #acbed7;
  }

  &__category-selector {
    border-color: #e4eaf4 !important;

    span {
      color: $darkTextColor;
      font-size: 14px !important;
    }

    .anticon {
      font-size: 12px;
    }
  }

  .ant-radio-group {
    margin-top: 10px;
  }

  .ant-radio-wrapper {
    margin-right: 50px;
    color: $darkTextColor;
  }
}
</style>
